TS.ns('WL');

WL.scoringHistoryModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var historyList = me.getDomainProperty('dgScoringHistory_Property');
        if (historyList) {

            historyList.executeDefault = function () {
                var historyList = me.getDomainProperty('dgScoringHistory_Property');
                var HistoryId = historyList.SelectedItem().HistoryId;
                me.performServerCommand('LoadScoringHistoryDetails', true, { HistoryId: HistoryId }, true);
            }  
        }

    }
});

